import React, { useEffect, useRef, useState } from "react";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
export const GooglePlacesInput = ({
  setValue,
  value,
  label,
  placeholder,
  error,
  className = "",
}) => {
  const serviceRef = useRef(null);
  useEffect(() => {
    if (window.google?.maps?.places) {
      serviceRef.current = new window.google.maps.places.PlacesService(
        document.createElement("div")
      );
    }
  }, []);
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      border: `1px solid ${error ? "red" : "#ced4da"}`,
      borderRadius: "10px", // Bootstrap border radius
      minHeight: "60px",
      width: "360px",
      boxShadow: "none",
      fontSize: "1rem",
      paddingLeft: "6px",
      backgroundColor: "#fff",
      "&:hover": {
        borderColor: error ? "red" : "#000000",
      },
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
      color: "#00000",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#6c757d",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#212529",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };



  return (
    <div>
      {label && <label className="form-label mb-1">{label}</label>}
      <GooglePlacesAutocomplete
        apiKey={apiKey}
        debounce={300}
      
        selectProps={{
          
          placeholder,
          styles: customStyles,
          classNamePrefix: "normal-input",
    
          onChange: (val) => {
            const placeId = val?.value?.place_id;
            if (!placeId || !serviceRef.current) return;
            serviceRef.current.getDetails(
              {
                placeId,
                fields: ["formatted_address", "geometry"],
              },
              (place, status) => {
                if (
                  status === window.google.maps.places.PlacesServiceStatus.OK
                ) {
                  const lat = place.geometry.location.lat();
                  const lng = place.geometry.location.lng();
                  let payload = {
                    address: place.formatted_address,
                    lat,
                    lng,
                  };
                  setValue(payload);
                } else {
                  console.error("Place details request failed:", status);
                }
              }
            );
          },
        }}
        onLoadFailed={(e) => console.error("Google API Load Failed:", e)}
      />
    </div>
  );
};
